import React from 'react'
import propTypes from 'prop-types'
import { Doughnut } from 'react-chartjs-2'

import { buildChartJsOptionsProp } from './options'
import { buildChartJsPluginProp } from './plugins'

import { getChartHeight } from '@utils/heights'

export const DoughnutChart = (props) => {
  return (
    <div className={props.className} style={{ height: getChartHeight(props.height), width: props.width }}>
      <Doughnut
        options={buildChartJsOptionsProp(props.options)}
        data={props.data}
        plugins={buildChartJsPluginProp(props.mainText, props.subText)}
      />
    </div>
  )
}

DoughnutChart.propTypes = {
  className: propTypes.string,
  data: propTypes.object.isRequired,
  options: propTypes.object,
  height: propTypes.string,
  width: propTypes.string,
  mainText: propTypes.string,
  subText: propTypes.string,
}

DoughnutChart.defaultProps = {
  className: '',
  options: {},
  height: '',
  width: '',
}

